import { WizardBar, WizardHead, WizardFoot, WizardList } from './WizardChrome';

// Who is actually at the park.
//
// This closes a real gap rather than adding a feature: `plan.absentPlayerIds` is
// already wired through every surface, and every tab already filters on it, but
// until now the ONLY way to set it was a swipe-right gesture buried on a row of
// the Game Plan grid. Most coaches never found it. Same data, a front door.

export const AvailabilityScreen = ({ players, absentPlayerIds, onToggleAbsent, onDone }: {
  players: any[];
  absentPlayerIds: string[];
  onToggleAbsent: (playerId: string) => void;
  onDone: () => void;
}) => {
  const out = players.filter((p: any) => absentPlayerIds.includes(p.id)).length;
  const present = players.length - out;

  return (
    <>
      <WizardBar label="Availability" onBack={onDone} />
      <WizardHead
        title="Who is here?"
        sub="Anyone switched off is left out of the lineup, the defense and the bullpen."
      />

      <div className="flex-1 overflow-y-auto bg-canvas px-4 pt-4">
        <WizardList>
          {players.map((p: any, i: number) => {
            const isOut = absentPlayerIds.includes(p.id);
            return (
              <div
                key={p.id}
                className={`flex items-center gap-3 px-4 py-3.5 ${i === players.length - 1 ? '' : 'border-b border-hairline'}`}
              >
                <span className={`flex-1 min-w-0 text-base font-semibold tracking-[-0.012em] truncate ${isOut ? 'text-ink-mute line-through' : 'text-ink'}`}>
                  {p.name}
                </span>
                <span className="text-sm text-ink-2 tabular-nums shrink-0">#{p.number}</span>
                <button
                  role="switch"
                  aria-checked={!isOut}
                  aria-label={`${p.name} ${isOut ? 'is out' : 'is available'}`}
                  onClick={() => onToggleAbsent(p.id)}
                  className={`relative w-11 h-6 rounded-full shrink-0 transition-colors ${isOut ? 'bg-track' : 'bg-accent'}`}
                >
                  <span
                    className={`absolute top-[3px] w-[18px] h-[18px] rounded-full bg-surface transition-all ${isOut ? 'left-[3px]' : 'left-[23px]'}`}
                  />
                </button>
              </div>
            );
          })}
        </WizardList>
        <div className="h-4" />
      </div>

      <WizardFoot
        primaryLabel="Done"
        onPrimary={onDone}
        secondaryLabel={`${present} in${out > 0 ? `, ${out} out` : ''}`}
      />
    </>
  );
};
